import { setBilling, setTariffs } from "../../../store/slices/billingSlice";
import { removeUser } from "../../../store/slices/userSlice";
import { errorToast } from "../../methods/toast";
import { $authHost } from "../http";

// let userId = localStorage.getItem("@storage_User_Id");

export const getTariffs = () => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(`/billing/tariff/list`);

      if (data.code === 200) {
        dispatch(setTariffs(data.tariffs));
        localStorage.setItem("tariffsData", JSON.stringify(data.tariffs));
      } else {
        errorToast("Ошибка получения тарифов");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 404) {
          errorToast("Тарифы не найдены.");
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("error get tariffs", error);
    }
  };
};

export const refillBalance = (dataReq, closeModal, setIsLoading) => {
  return async (dispatch) => {
    setIsLoading(true);
    try {
      const { data } = await $authHost.post(`/billing/order/ballance`, dataReq);

      if (data.code === 200) {
        setIsLoading(false);
        closeModal();
        window.open(data.paymentLink);
      } else {
        errorToast(
          "Ошибка пополнения баланса: " + (data.message || "Неизвестная ошибка")
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("error refillBalance", error);
    }
  };
};

export const getBilling = (id, setLoading = () => {}) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.get(`/billing/data?userId=${id}`);

      if (data.code === 200) {
        dispatch(setBilling(data.billing));
        localStorage.setItem("billingData", JSON.stringify(data.billing));
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      } else {
        errorToast(
          "Ошибка получения данных о биллинге: " +
            (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("error getBilling", error);
    }
  };
};

export const buyTariffByCard = (dataReq, setLoading, closeModal) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(`/billing/order/tariff`, dataReq);

      if (data.code === 200) {
        setLoading(false);
        closeModal();
        window.open(data.paymentLink);
      } else {
        setLoading(false);
        errorToast(
          "Ошибка покупки тарифа: " + (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("error buyTariffByCard", error);
    }
  };
};

export const buyTariffByBallance = (dataReq, setLoading, setIsSuccess) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/billing/ballance/tariff`,
        dataReq
      );

      if (data.code === 200) {
        console.log("data buyTariff by ballance", data);
        setLoading(false);
        setIsSuccess(true);
      } else {
        setLoading(false);
        errorToast(
          "Ошибка покупки тарифа: " + (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("error buyTariffByBallance", error);
    }
  };
};

export const tariffAutoRenewal = (dataTariff) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(`/billing/data`, dataTariff);

      if (data.code === 200) {
        console.log("data tariffAutoRenewal", data);
        dispatch(setBilling(data.billing));
        localStorage.setItem("billingData", JSON.stringify(data.billing));
      } else {
        errorToast(
          "Ошибка обновления тарифа: " + (data.message || "Неизвестная ошибка")
        );
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("tariffAutoRenewal error", error);
    }
  };
};
